app.directive('translateDateObjectSchedule', function ($timeout) {
	return {
		controller: function ($scope) {
			return {};
		},
		requires: 'translateDateObjectSchedule',
		link: function (scope, element, attrs, thisController) {

			$timeout(function () {

				thisController.html = element[0].innerHTML;

				// CLEAN THE STRING TO GET A CLEAN NAME DAY
				var content_temp1 = thisController.html.replace('<span class="day ng-binding">', '');
				var content_temp2 = content_temp1.replace('</span>', '').toLowerCase();

				var day_name = '';

				for (var i = 0, len = content_temp2.length; i < len; i++) {
					// CHECK IF IS A CHAR
					if (content_temp2[i].match(/[a-z]/i)) {
						day_name += content_temp2[i];
					}
				}

				lang = scope.currentLang ? scope.currentLang : lang;

				// CHECK THE ACTIVE LANGUAGE
				if (lang == 'bg') {
					// ASSIGN A DIFFERENT TRANSLATION FOR EACH DAY
					switch (day_name) {
						case 'monday':
							element.html('<span class="day">Понеделник</span>');
							break;
						case 'tuesday':
							element.html('<span class="day">Вторник</span>');
							break;
						case 'wednesday':
							element.html('<span class="day">Сряда</span>');
							break;
						case 'thursday':
							element.html('<span class="day">Четвъртък</span>');
							break;
						case 'friday':
							element.html('<span class="day">Петък</span>');
							break;
						case 'saturday':
							element.html('<span class="day">Събота</span>');
							break;
						case 'sunday':
							element.html('<span class="day">Неделя</span>');
							break;
					}
				}else if (lang == 'es'){
					// ASSIGN A DIFFERENT TRANSLATION FOR EACH DAY
					switch (day_name) {
						case 'monday':
							element.html('<span class="day">Lunes</span>');
							break;
						case 'tuesday':
							element.html('<span class="day">Martes</span>');
							break;
						case 'wednesday':
							element.html('<span class="day">Miércoles</span>');
							break;
						case 'thursday':
							element.html('<span class="day">Jueves</span>');
							break;
						case 'friday':
							element.html('<span class="day">Viernes</span>');
							break;
						case 'saturday':
							element.html('<span class="day">Sábado</span>');
							break;
						case 'sunday':
							element.html('<span class="day">Domingo</span>');
							break;
					}
				}else if (lang == 'esc'){
					// ASSIGN A DIFFERENT TRANSLATION FOR EACH DAY
					switch (day_name) {
						case 'monday':
							element.html('<span class="day">Dilluns</span>');
							break;
						case 'tuesday':
							element.html('<span class="day">Dimarts</span>');
							break;
						case 'wednesday':
							element.html('<span class="day">Dimecres</span>');
							break;
						case 'thursday':
							element.html('<span class="day">Dijous</span>');
							break;
						case 'friday':
							element.html('<span class="day">Divendres</span>');
							break;
						case 'saturday':
							element.html('<span class="day">Dissabte</span>');
							break;
						case 'sunday':
							element.html('<span class="day">Diumenge</span>');
							break;
					}
				}else if (lang == 'esm'){
					// ASSIGN A DIFFERENT TRANSLATION FOR EACH DAY
					switch (day_name) {
						case 'monday':
							element.html('<span class="day">Dilluns</span>');
							break;
						case 'tuesday':
							element.html('<span class="day">Dimarts</span>');
							break;
						case 'wednesday':
							element.html('<span class="day">Dimecres</span>');
							break;
						case 'thursday':
							element.html('<span class="day">Dijous</span>');
							break;
						case 'friday':
							element.html('<span class="day">Divendres</span>');
							break;
						case 'saturday':
							element.html('<span class="day">Dissabte</span>');
							break;
						case 'sunday':
							element.html('<span class="day">Diumenge</span>');
							break;
					}
				}else if (lang == 'pt'){
					// ASSIGN A DIFFERENT TRANSLATION FOR EACH DAY
					switch (day_name) {
						case 'monday':
							element.html('<span class="day">Segunda-feira</span>');
							break;
						case 'tuesday':
							element.html('<span class="day">Terça-feira</span>');
							break;
						case 'wednesday':
							element.html('<span class="day">Quarta-feira</span>');
							break;
						case 'thursday':
							element.html('<span class="day">Quinta-feira</span>');
							break;
						case 'friday':
							element.html('<span class="day">Sexta-feira</span>');
							break;
						case 'saturday':
							element.html('<span class="day">Sábado</span>');
							break;
						case 'sunday':
							element.html('<span class="day">Domingo</span>');
							break;
					}
				}else if (lang == 'it'){
					// ASSIGN A DIFFERENT TRANSLATION FOR EACH DAY
					switch (day_name) {
						case 'monday':
							element.html('<span class="day">Lunedì</span>');
							break;
						case 'tuesday':
							element.html('<span class="day">Martedì</span>');
							break;
						case 'wednesday':
							element.html('<span class="day">Mercoledì</span>');
							break;
						case 'thursday':
							element.html('<span class="day">Giovedì</span>');
							break;
						case 'friday':
							element.html('<span class="day">Venerdì</span>');
							break;
						case 'saturday':
							element.html('<span class="day">Sabato</span>');
							break;
						case 'sunday':
							element.html('<span class="day">Domenica</span>');
							break;
					}
				}else if (lang == 'ro'){
					// ASSIGN A DIFFERENT TRANSLATION FOR EACH DAY
					switch (day_name) {
						case 'monday':
							element.html('<span class="day">Luni</span>');
							break;
						case 'tuesday':
							element.html('<span class="day">Marţi</span>');
							break;
						case 'wednesday':
							element.html('<span class="day">Miercuri</span>');
							break;
						case 'thursday':
							element.html('<span class="day">Joi</span>');
							break;
						case 'friday':
							element.html('<span class="day">Vineri</span>');
							break;
						case 'saturday':
							element.html('<span class="day">Sâmbătă</span>');
							break;
						case 'sunday':
							element.html('<span class="day">Duminică</span>');
							break;
					}
				}
			});
		}
	}
})